<div class="main-container-position">
  <div class="container-width">
    <div class="container mx-auto p-4 sm:p-6 md:p-8">
      <div>
        <div class="flex justify-between flex-wrap">
          <h1 class="text-2xl sm:text-3xl md:text-3xl" i18n>
            Fachbeirat Freigabe Bereich
          </h1>
        </div>
      </div>

      <div class="mt-8">
        <a
          href="#"
          target="_blank"
          class="text-blue-600 hover:text-blue-800 flex items-center gap-2"
        >
          <mat-icon>description</mat-icon>
          <span i18n>Zum Fachbeirat Onboarding Dokument</span>
        </a>
      </div>

      <div>
        <h2 class="text-lg sm:text-xl md:text-2xl" i18n>
          Zugeteilte Kategorien
        </h2>
        <div class="flex flex-wrap gap-2">
          @for (category of advisoryCategories$ | async; track category) {
            <mat-chip>
              {{ category.name }}
            </mat-chip>
          }
        </div>
      </div>

      @if (loading$ | async) {
        <div>
          <div class="animate-pulse">
            <div class="text-lg">Lade Daten...</div>
          </div>
        </div>
      }

      @if (error$ | async; as error) {
        <div class="text-red-600 p-4">
          <p>Fehler beim Laden der Daten: {{ error }}</p>
        </div>
      }

      @if (!(loading$ | async)) {
        <div>
          <h2 class="text-lg sm:text-xl md:text-2xl" i18n>
            Mir zugeteilt
            @if (offersCount$ | async; as count) {
              <span class="text-gray-500 text-sm">({{ count }})</span>
            }
          </h2>
          <div class="flex flex-wrap gap-4">
            @for (offer of offers$ | async; track offer) {
              <app-offer-card
                class="w-[231px]"
                [offer]="offer"
                [showStatus]="true"
                [fromAdvisoryBoard]="true"
                [showContextMenu]="false"
                [showActions]="true"
              ></app-offer-card>
            }
          </div>

          @if ((offers$ | async)?.length === 0) {
            <div class="text-gray-500 text-center py-8">
              <p>
                Keine neuen Angebote in Ihren zugeteilten Kategorien vorhanden.
              </p>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
